import React, { useContext, useEffect, useMemo, useState } from "react";
import { Tab } from "@headlessui/react";
import AppContext from "../contexts/AppContext";
import DataTable1 from "./DataTable1";
import EmptyTransactionIcon from "../icons/EmptyTransactionIcon";

const EmptyRecord = () => {
  return (
    <div className="grid place-content-center place-items-center h-96 bg-gray-100 rounded-sm mb-5">
      <EmptyTransactionIcon />
      <h2 className="font-semibold text-md">No records available</h2>
    </div>
  );
};

function TabNotificationList1({
  options = [],
  setLoading,
  filterOption,
  accessOption,
  gridType,
  grid = [],
}) {
  const {
    context: { menuId },
  } = useContext(AppContext);

  const [activeIndex, setActiveIndex] = useState(0);
  const [loadingPeriodData, setLoadingPeriodData] = useState(false);
  const [dataGridMap, setDataGridMap] = useState({});
  const [dataGridResMap, setDataGridResMap] = useState({});
  const [activePageMap, setActivePageMap] = useState({});

  const setGridFor = (idx, grid) =>
    setDataGridMap((prev) => ({ ...prev, [idx]: grid }));

  const setDataGridResFor = (idx, res) =>
    setDataGridResMap((prev) => ({ ...prev, [idx]: res }));

  const setActivePageFor = (idx, page) =>
    setActivePageMap((prev) => ({ ...prev, [idx]: page }));

  // const tabs = (options ?? [])[0] ?? {};

  const tabs = useMemo(() => {
    const source = Array.isArray(options) && options?.length ? options : [];

    return source.filter(Boolean);
  }, [options]);

  const cacheResetKey = useMemo(
    () =>
      JSON.stringify({
        menuId,
        filterOption,
        accessOption,
      }),
    [menuId, filterOption, accessOption],
  );

  // Reset tab-level cached rows/pages whenever upstream filters change.
  // Without this, stale tab caches can override fresh API rows from `options`.
  useEffect(() => {
    setDataGridMap({});
    setDataGridResMap({});
    setActivePageMap({});
  }, [cacheResetKey]);

  useEffect(() => {
    if (activeIndex >= tabs?.length) {
      setActiveIndex(0);
    }
  }, [tabs, activeIndex]);

  // useEffect(() => {
  //   fetchActivePeriodDataIniital(tabs[activeIndex], {
  //     isInitial: true,
  //   });
  // }, [menuId]);

  // const fetchActivePeriodDataIniital = (
  //   report, // explicit report object to use (initialActiveReport)
  //   period, // explicit period object to use (schema)
  //   { isInitial = false } = {},
  // ) => {
  //   const requestId = ++latestRequestRef.current;
  //   // setLoadingPeriodData(true);

  //   // defensive checks
  //   if (!report) {
  //     console.log("fetchInitial aborted: no report passed", { report, period });
  //     // setLoadingPeriodData(false);
  //     return;
  //   }

  //   // Use the passed-in period (not the stateful activePeriod)
  //   const schemaId = period?.ID ?? null;

  //   const postData = {
  //     layoutId: report.layoutid,
  //     // schemaId,
  //     target: report.target,
  //     targetId: report.targetid,
  //     dateFilter: filterOption,
  //     accessFilter: accessOption,
  //   };

  //   appFetch
  //     .get(appendQueryToUri(apiEndpoints.menuView, postData))
  //     .then((res) => {
  //       if (requestId !== latestRequestRef.current) {
  //         console.log("Ignored stale initial response", requestId);
  //         return;
  //       }
  //       console.log("the response", res);
  //       // const option = (res?.options || [])[0] || {};
  //       // const grid = option.grid || [];
  //       // const gridSummary = grid.length ? option.grid_summary || [] : [];

  //       // setActivePage(0);
  //       // setDataGridRes(option);
  //       // setDataGrid(grid);
  //       // setDataSummaryRes(gridSummary);

  //       // if (isInitial) {
  //       //   const parsedPeriod = JSON.parse(option.period || "[]");
  //       //   const group = groupBy(parsedPeriod || [], (i) => i.period_type);
  //       //   const types = Object.keys(group);
  //       //   const type = types[0];
  //       //   const active = group[type]?.slice(-1)?.at(0);

  //       //   setPeriodTypeGroup(group);
  //       //   setPeriodTypes(types);
  //       //   setActivePeriodType(type);
  //       //   setActivePeriod(active);
  //       // }
  //     })
  //     .catch((e) => {
  //       console.log("fetchActivePeriodDataIniital error", e?.message ?? e);
  //     })
  //     .finally(() => {
  //       if (requestId === latestRequestRef.current) {
  //         // setLoadingPeriodData(false);
  //       }
  //     });
  // };

  if (!tabs?.length) return <EmptyRecord />;

  return (
    <div className="w-full">
      <Tab.Group selectedIndex={activeIndex} onChange={setActiveIndex}>
        <Tab.List className="flex gap-2 overflow-x-auto border-b border-gray-200 px-2">
          {tabs.map((item, idx) => {
            const title = item?.name || item?.type || `Tab ${idx + 1}`;

            return (
              <Tab
                key={`${title}-${idx}`}
                className={({ selected }) =>
                  [
                    "whitespace-nowrap px-4 py-3 text-sm font-medium outline-none transition",
                    selected
                      ? "border-b-2 border-primary text-primary"
                      : "text-gray-500 hover:text-gray-800",
                  ].join(" ")
                }
              >
                {title}
              </Tab>
            );
          })}
        </Tab.List>

        <Tab.Panels className="mt-4">
          {tabs.map((item, idx) => {
            let itemGrid = item?.grid || [];
            const itemGridSource = dataGridMap?.[idx] ?? itemGrid;
            const itemGridKeys = Object.keys(
              (itemGridSource ?? [])[0] || {},
            )?.filter(
              (head) =>
                !["ID", "drillable", "drillid", "targetid"].includes(head),
            );

            return (
              <div key={idx}>
                <Tab.Panel
                  key={`${item?.type || "tab"}-${idx}`}
                  className="outline-none"
                >
                  {/* {renderComponent(item, {
                  setLoading,
                  activeIndex,
                  tabIndex: idx,
                })} */}

                  {item.grid && item?.grid.length ? (
                    <DataTable1
                      loading={loadingPeriodData}
                      setLoading={setLoadingPeriodData}
                      // per-tab setters
                      setGrid={(grid) => setGridFor(idx, grid)}
                      setDataGridRes={(res) => setDataGridResFor(idx, res)}
                      dataGridRes={dataGridResMap?.[idx] ?? item}
                      headerProps={item}
                      rows={itemGridSource}
                      headers={itemGridKeys}
                      setNewPage={(page) => setActivePageFor(idx, page)}
                      page={activePageMap?.[idx] ?? 0}
                      // setSearch={(value) => setDataSearch(value)}
                      // search={search}
                      showSearch={false}
                      gridType={item?.gridtype}
                      dateFilter={filterOption}
                      accessFilter={accessOption}
                      usePageLength={false}
                    />
                  ) : (
                    <EmptyRecord />
                  )}
                </Tab.Panel>
              </div>
            );
          })}
        </Tab.Panels>
      </Tab.Group>
    </div>
  );
}

export default TabNotificationList1;
